import { Icon } from 'antd';
import React, { useState } from 'react';
// @ts-ignore
import Transition from 'react-transition-group/Transition';

interface FadeInProps extends React.Props<any> {
  target: JSX.Element;
  className?: string;
  style?: React.CSSProperties;
  // 像素单位宽度
  width: number;
  onFadeStateChange?: (isFade: boolean) => void;
}

export function FadeIn(props: FadeInProps) {
  const duration = 300;
  const { target, style, className, onFadeStateChange, width } = props;
  const transitionStyles = {
    entering: { right: -(width + 80) + 'px' },
    entered: { right: '0' },
  };
  const [isFade, setIsFade] = useState(false);

  const handleDoc = () => {
    setIsFade(false);
    if (onFadeStateChange) {
      onFadeStateChange(false);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      {React.cloneElement(target, {
        onClick: () => {
          setIsFade(true);
          if (onFadeStateChange) {
            onFadeStateChange(true);
          }
        },
      })}
      <Transition timeout={duration} in={isFade} unmountOnExit={true}>
        {(state: string) => {
          return (
            <div
              className={className}
              style={Object.assign(
                { width: width + 'px' },
                style,
                {
                  position: 'absolute',
                  right: -(width + 80) + 'px',
                  transition: `right ${duration}ms ease-in-out`,
                  zIndex: 99,
                  background: '#fff',
                  borderRadius: '4px',
                  boxShadow: '#00000040 0px 1px 6px 0px',
                  padding: '8px',
                },
                transitionStyles[state]
              )}>
              <Icon
                type="close"
                style={{ float: 'right', cursor: 'pointer' }}
                onClick={handleDoc}
              />
              {props.children}
            </div>
          );
        }}
      </Transition>
      {isFade ? (
        <div
          onClick={handleDoc}
          style={{
            width: '100vw',
            height: '100vh',
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 98,
          }}
        />
      ) : null}
    </div>
  );
}
